let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lDMqz")).then(() => parcelRequire('aHiPW'));